import { FC } from 'react';

import { prepareProfRolesOnSave } from 'utils/profRoles';

import cpcFlexibleSpecializationSaveButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/cpc_flexible_specialization_save_button_click';
import { Link, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import useProfRolesTranslations, { TranslationNamespaces } from 'hooks/translation/useProfRolesTranslations';
import useTrls from 'hooks/translation/useTrls';
import useIsNewCampaign from 'utils/campaign/hooks/useIsNewCampaign';

import CompositeSelection from 'components/common/CompositeSelection/CompositeSelection';
import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';
import { AdProfessionsInput } from 'components/CpcFlexibleCreate/CpcForm/AdProfessions/AdProfessionsInput';
import { useData } from 'components/CpcFlexibleCreate/CpcForm/AdProfessions/useData';

import { selectProfessions } from 'store/autoReducers';
import { setCampaignProfessions } from 'store/models/createCampaign';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    reset: 'AdCreate.AdForm.ProfRoles.Popup.resetButton',
};

export const AdProfessions: FC = () => {
    const adProfessions = useSelector((state) => state.createCampaign.adProfessions);
    const items = useSelector(selectProfessions);
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const isCampaignProcessCreate = useIsNewCampaign();

    const dispatch = useDispatch();
    const translations = useProfRolesTranslations(TranslationNamespaces.AdCreate);
    const trl = useTrls();
    const data = useData();

    const onChange = (selectedProfessions: string[]) => {
        if (isCampaignProcessCreate) {
            cpcFlexibleSpecializationSaveButtonClick({ vacancyId });
        }

        dispatch(setCampaignProfessions(prepareProfRolesOnSave(items, selectedProfessions)));
    };

    const handleReset = () => {
        onChange([]);
    };

    return (
        <MagritteFormField
            input={
                <CompositeSelection.Root collection={data.collection} value={adProfessions} onChange={onChange}>
                    <VSpacingContainer default={20}>
                        <AdProfessionsInput provider={data.provider} />
                        <CompositeSelection.Chips containerDataQa="professions-chips-container" />
                        {adProfessions.length > 0 && (
                            <Link data-qa="clear-profroles" onClick={handleReset}>
                                {trl(TrlKeys.reset)}
                            </Link>
                        )}
                        <VSpacing default={12} />
                    </VSpacingContainer>
                    <CompositeSelection.TreeSelectorModal
                        texts={{
                            title: trl(translations.legend),
                        }}
                    />
                </CompositeSelection.Root>
            }
            label={trl(translations.legend)}
        />
    );
};
